import Styled from 'styled-components'
import { IoIosInformationCircle } from 'react-icons/io'
import { RiCloseFill } from "react-icons/ri";

export const Information = Styled.div`
padding: 15px;
background: #F6F6F6;
line-height: 20px;
margin-top: 0;

display: flex;
    p {
        color: ${props => props.theme.primary};
        font-weight: 400;
        font-size: 12px;
        margin-bottom: 0;
    span {
        text-decoration: none;
        font-weight: bold;
        color: ${props => props.theme.primary};
        background: none;
        padding: 0;
        border: none;
    }
}
`
export const InfromationIcon = Styled(IoIosInformationCircle)`
margin-right: 10px;
height: 30px;
width: 30px;
color: #006C8E;
`

export const InfromationIconOpen = Styled(IoIosInformationCircle)`
margin-right: 10px;
height: 38px;
width: 38px;
color: #006C8E;
`

export const Close = Styled(RiCloseFill)`
float: right;
color: black;
width: 25px;
height: 25px;
margin-top: 10px;
margin-right: 10px;
cursor: pointer;
`
export const ContainerRegulation = Styled.div`
background: #FFFFFF;
text-align: center;


.text{
margin: 6%;
color: #474646;    
font-weight: 400;
font-size: 12px;
text-align: left;
}
`
export const DivParagraph = Styled.div`
padding-top: 5px;
margin: 0 6%;
display: flex;
align-items: center;
text-align: left;
p{
    margin-bottom: 0;
}

.att{
color: #263238;
font-weight: 700;
font-size: 17px;
}

.location{
color: rgba(71, 70, 70, 0.5);
font-weight: 400;
font-size: 14px;
}

`
export const ButtonConfirm = Styled.button`
height: 30px;
width: 187px;
border-radius: var(--button-border-radius);
background: #050922;
border: none;
color: white;
margin-bottom: 18px;
`
